module.exports = __webpack_public_path__ + "img/cusromerLogo1.a5924dbf.png";